<script lang="ts">
    import type {StringKeyedObject} from "@docsndata/lang-util";

    export let errors: StringKeyedObject
    export let name: string
</script>

{#if errors[name]}
    <div class="invalid-feedback">
        {errors[name]}
    </div>
{/if}

<style>
    .invalid-feedback {
        display: block;
    }
</style>
